import { isFedM } from './env';
import { defineMessage } from 'react-intl';

export const DEFAULT_MINIMUM_PASSWORD_LENGTH = 8;
export const FEDRAMP_MINIMUM_PASSWORD_LENGTH = 12;

export const minimumPasswordLengthMessage = defineMessage({
  id: 'password.strength.level.minimum.template',
  defaultMessage: 'Password must have at least {minimumPasswordLength} characters',
});

export const getMinimumPasswordLength = () =>
  isFedM() ? FEDRAMP_MINIMUM_PASSWORD_LENGTH : DEFAULT_MINIMUM_PASSWORD_LENGTH;
